<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!applied">
        <project-page-header ref="pageHeader" :id="projectId">
          <template v-slot:actions>
            <a-space>
              <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
            </a-space>
          </template>
        </project-page-header>
        <div class="panel-body">
          <div class="page-title">制订项目计划</div>
          <div class="panel-info-section">
            <div v-if="data.taskCheckResult == -1">
              <a-alert class="v-mb-sm no-border" type="error">
                <div slot="message">
                  <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />此项目计划已被驳回</div>
                  <div class="flex v-mt-xs">
                    <span class="text-right text-grey">审核意见：</span>
                    <span class="col text-red" v-html="$utils.convertToHtml(data.taskCheckOpinion)  "></span>
                  </div>
                </div>
              </a-alert>
            </div>
            <div class="flex items-center">
              <a-space :size="4" class="v-mb-sm">
                <a-button size="small" icon="plus" type="indigo" @click="handleNewTask('append')">添加任务分类</a-button>
              </a-space>
            </div>
            <div class="flex">
              <div class="col">
                <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedTableKeys" :pagination="false" :data-source="tasks" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
                  <a-table-column title="操作" data-index="action" :width="90" align="center">
                    <template slot-scope="text, record, index">
                      <a-space class="icon-actions" :size="2">
                        <span class="icon-action" title="编辑" @click="record.editing = true" v-if="!record.editing"><a-icon type="form" /></span>
                        <span class="icon-action" title="确定" @click="record.editing = false" v-else><a-icon type="check" /></span>
                        <!-- v-if="record.taskType == '-1' || record.taskType == '0'" -->
                        <a-dropdown placement="bottomLeft">
                          <span class="icon-action" title="添加"><a-icon type="plus" /></span>
                          <a-menu slot="overlay">
                            <template v-if="record.isRoot">
                              <a-menu-item key="before" @click="handleNewTask('before', record, index)">
                                <a-icon class="text-indigo" type="border-top" />
                                向前添加任务分类
                              </a-menu-item>
                              <a-menu-item key="after" @click="handleNewTask('after', record, index)">
                                <a-icon class="text-indigo" type="border-bottom" />
                                向后添加任务分类
                              </a-menu-item>
                              <a-menu-item key="append" @click="handleNewSubTask('append', record, index)">
                                <a-icon class="text-indigo" type="border-right" />
                                添加任务
                              </a-menu-item>
                            </template>
                            <template v-else>
                              <a-menu-item key="before" @click="handleNewSubTask('before', record, index)">
                                <a-icon class="text-indigo" type="border-top" />
                                向前添加任务
                              </a-menu-item>
                              <a-menu-item key="after" @click="handleNewSubTask('after', record, index)">
                                <a-icon class="text-indigo" type="border-bottom" />
                                向后添加任务
                              </a-menu-item>
                            </template>
                          </a-menu>
                        </a-dropdown>
                        <span class="icon-action text-red" title="删除" @click="handleRemoveTask(record, index)"><a-icon type="delete" /></span>
                      </a-space>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="taskName" :ellipsis="true" :width="280" align="left">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      任务名称
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position flex items-center" :style="{ display: 'inline-block', width: hasChildren ? `calc(100% - ${record.isRoot ? 25 : 45}px)` : '100%' }">
                        <a-input size="small" :placeholder="record.isRoot ? '任务分类名称' : '任务名称'" style="width: 100%" v-model="record.taskName" :ref="`taskName-${record.uid}`" v-if="record.editing" />
                        <span v-else>{{ record.taskName || '-' }}</span>
                        <a-tooltip placement="top" :title="record.isRoot ? '任务分类名称为空' : '任务名称为空'" v-if="!record.taskName || !record.taskName.trim()">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="taskType" :width="98" align="center" :ellipsis="true">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      任务类型
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <a-select size="small" placeholder="请选择" v-model="record.taskType" :ref="`taskType-${record.uid}`" style="width: 100%" v-if="record.editing">
                          <a-select-option value="活动">活动</a-select-option>
                          <a-select-option value="文档">文档</a-select-option>
                          <a-select-option value="其他">其他</a-select-option>
                        </a-select>
                        <span v-else>{{ record.taskType || '-' }}</span>
                        <a-tooltip placement="top" title="未设置任务类型" v-if="!record.taskType">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="range" :width="190" align="center" :ellipsis="true">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      任务周期
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <a-range-picker
                          size="small"
                          v-model="record.dates"
                          format="YYYY-MM-DD"
                          value-format="YYYY-MM-DD"
                          :placeholder="['开始日期', '结束日期']"
                          @change="(date, dateString) => onDateRangeChange(dateString, record)"
                          :ref="`datePicker-${record.uid}`"
                          style="width: 100%"
                          v-if="record.editing"
                        />
                        <span v-else>{{ record.startDate ? record.startDate + '~' + record.endDate : '-' }}</span>
                        <a-tooltip placement="top" title="未设置任务周期" v-if="!record.startDate">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                      <span v-else>{{ record.startDate ? record.startDate + '~' + record.endDate : '' }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="历时（天）" data-index="period" :width="90" align="center">
                    <template slot-scope="text, record">
                      <span v-if="record.startDate && record.endDate">{{ $utils.diffDays(record.startDate, record.endDate) }}d</span>
                      <span v-else>-</span>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="owner" :width="100" align="center" :ellipsis="true">
                    <span slot="title">责任人</span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <!-- <a-select size="small" placeholder="请选择" v-model="record.ownerType" :ref="`ownerType-${record.uid}`" style="width: 100%" v-if="record.editing">
                          <a-select-option :value="1">项目官员</a-select-option>
                          <a-select-option :value="2">施工方</a-select-option>
                        </a-select> -->
                        <a-auto-complete
                          v-model="record.owner"
                          size="small"
                          style="width: 100%"
                          placeholder="请选择"
                          allow-clear
                          option-label-prop="label"
                          :filter-option="filterOption"
                          :dropdown-match-select-width="true"
                          @select="(value, option) => onOwnerSelect(value, record)"
                          @change="value => onOwnerChange(value, record)"
                          v-if="record.editing"
                        >
                          <template slot="dataSource">
                            <a-select-option v-for="item in users" :key="`${item.id}`" :label="item.realName">
                              <div class="ellipsis">{{ item.realName }}</div>
                            </a-select-option>
                          </template>
                        </a-auto-complete>
                        <span v-else>{{ record.owner }}</span>
                        <!-- <a-tooltip placement="top" title="未设置责任人" v-if="!record.owner">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip> -->
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column title="备注" data-index="remark" :width="200" align="left">
                    <template slot-scope="text, record" v-if="!record.isRoot">
                      <a-input size="small" v-model="record.remark" style="width: 100%" v-if="record.editing" />
                      <span v-else>{{ record.remark }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="对应费用明细" data-index="budget" align="left">
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <ul class="cell-list" v-if="record.budgets && record.budgets.length">
                          <li v-for="item in record.budgets" :key="item.budgetId">{{ item.pname }} — {{ item.name }} / {{ $utils.thousands(item.amount) }} 元</li>
                        </ul>
                        <span class="hover-line text-indigo" title="设置费用明细" @click="setBudgets(record)">设置</span>
                      </div>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </div>
            <div class="flex items-center v-mt-xs" v-if="tasks.length > 0">
              <span class="col font-xs">
                提示：
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                表示项不符合要求，提交至审核时有
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                标志将无法提交。
              </span>
            </div>
            <div class="text-center v-my-lg">
              <a-space>
                <template v-if="!data.taskState">
                  <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
                  <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交审核</a-button>
                </template>
                <a-button icon="left" type="default" key="back" @click="$router.go(-1)">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您制定的项目计划已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`../view?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
    <!-- 预算弹窗 -->
    <a-modal :mask-closable="false" :visible="showBudgetModal" :width="900" @cancel="cancelBudgetModal" @ok="onSaveTaskBudgets" centered title="设置对应费用明细">
      <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :row-selection="{ selectedRowKeys: selectedBudgetKeys, onChange: onSelectChange, getCheckboxProps }" :expanded-row-keys.sync="expandedBudgetKeys" :pagination="false" :data-source="budgetsTableData" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
        <a-table-column title="费用名称" data-index="name" :ellipsis="true" :width="250" align="left">
          <template slot-scope="text, record">
            {{ record.name || '-' }}
          </template>
        </a-table-column>
        <a-table-column title="费用年份" data-index="year" :width="80" align="center" :ellipsis="true">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot">{{ record.year || '-' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="单价" data-index="price" :width="100" align="right" :ellipsis="true">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot">{{ record.price || '-' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="数量" data-index="quantity" :width="66" align="right">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot">{{ record.quantity || '-' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="预算金额(元)" data-index="amount" :width="115" align="right">
          <template slot-scope="text, record">
            <span>{{ $utils.numInputFormatter(record.amount) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="预算备注" :ellipsis="true" data-index="remark" align="left">
          <template slot-scope="text, record">
            {{ record.remark }}
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { viewPrj } from '@/api/project/other'
import { applyTasks, getTasks, getBudgets } from '@/api/project/common'
import { createNewTask, convertTasksToTableData, convertBudgetsToTableData } from '@/utils/data'
import { listOwners } from '@/api/system/user'
export default {
  name: 'OtherPanDraft',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      loading: false,
      data: {},
      tasks: [],
      expandedTableKeys: [],
      saving: false,
      applied: false,
      showBudgetModal: false,
      budgets: [],
      budgetsTableData: [],
      expandedBudgetKeys: [],
      selectedBudgetKeys: [],
      currentRecord: {},
      users: [],
    }
  },
  computed: {
    hasChildren() {
      return this.tasks.some(item => item.children && item.children.length)
    },
  },
  watch: {
    $route() {
      this.projectId = +this.$route.query.id
    },
    tasks: {
      handler(records) {
        records.forEach(record => {
          let rootStartDate = undefined, rootEndDate = undefined
          if (record.children) {
            record.children.forEach(({ startDate, endDate }) => {
              if (startDate && endDate) {
                if (!rootStartDate || this.$moment(startDate).valueOf() < this.$moment(rootStartDate).valueOf()) {
                  rootStartDate = startDate
                }
                if (!rootEndDate || this.$moment(endDate).valueOf() > this.$moment(rootEndDate).valueOf()) {
                  rootEndDate = endDate
                }
              }
            })
          }
          record.startDate = rootStartDate
          record.endDate = rootEndDate
        })
      },
      deep: true,
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadProject()
        this.loadBudgets()
        this.loadOwners()
      }
    },
    loadProject() {
      let id = this.projectId
      viewPrj(id).then(({ data }) => {
        if (data.success) {
          this.data = data.result
        }
      })
      this.loading = true
      getTasks(id).then(({ data }) => {
        this.loading = false
        if (data.success) {
          let records = convertTasksToTableData(data.result)
          this.tasks = records
          this.expandedTableKeys = records.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
    },
    loadOwners() {
      listOwners(this.projectId).then(({ data }) => {
        if (data.success) {
          this.users = data.result
        }
      })
    },
    loadBudgets() {
      getBudgets(this.projectId).then(({ data }) => {
        if (data.success) {
          let records = data.result
          this.budgets = records
          this.budgetsTableData = convertBudgetsToTableData(records)
          this.expandedBudgetKeys = this.budgetsTableData.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.propsData.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onOwnerChange(value, record) {
      record.ownerId = undefined
      record.owner = undefined
    },
    onOwnerSelect(value, record) {
      record.ownerId = value
      record.owner = value ? this.users.find(u => u.id == value).realName : undefined
    },
    onDateRangeChange(dateString, record) {
      let [startDate, endDate] = dateString
      record.startDate = startDate
      record.endDate = endDate
    },
    handleNewTask(action, task, index) {
      // let tasks = this.tasks
      let newItem = createNewTask()
      newItem.editing = true
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 1
      if (action == 'append') {
        this.tasks.push(newItem)
      } else {
        this.tasks.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleNewSubTask(action, item, index) {
      let newItem = createNewTask()
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 0
      newItem.editing = true
      if (action == 'append') {
        newItem.puid = item.uid
        if (!item.children) {
          item.children = []
        }
        newItem.parent = item
        // newItem.professionStartDate = item.startDate
        item.children.push(newItem)
        this.tasks.splice(index, 1, { ...item })
        this.$nextTick(() => {
          this.expandedTableKeys.push(item.uid)
        })
      } else {
        let parent = this.tasks.find(d => d.uid == item.puid)
        newItem.parent = parent
        newItem.puid = parent.uid
        parent.children.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleRemoveTask(item, index) {
      if (item.isRoot) {
        this.tasks.splice(index, 1)
      } else {
        let parent = this.tasks.find(d => d.uid == item.puid)
        parent.children.splice(index, 1)
        if (parent.children.length == 0) {
          parent.children = undefined
        }
      }
    },
    validTask(item) {
      let { uid, taskName, isRoot, taskType, dates } = item
      if (!taskName || !taskName.trim()) {
        item.editing = true
        this.$message.warn('任务名称不能为空')
        this.$nextTick(() => {
          this.$refs[`taskName-${uid}`].focus()
        })
        return false
      }
      if (!isRoot) {
        if (!taskType) {
          item.editing = true
          this.$message.warn('未设置任务类型')
          this.$nextTick(() => {
            this.$refs[`taskType-${uid}`].focus()
          })
          return false
        }
        if (dates.length == 0) {
          item.editing = true
          this.$message.warn('未设置任务周期')
          this.$nextTick(() => {
            this.$refs[`datePicker-${uid}`].focus()
          })
          return false
        }
      }
      return true
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      let tasks = this.tasks
      if (tasks.length === 0) {
        this.$message.warn('未添加任务')
        return
      }
      if (nextStep) {
        for (let index = 0; index < tasks.length; index++) {
          let item = tasks[index]
          if (!this.validTask(item)) {
            return false
          }
          if (item.children) {
            for (let i = 0; i < item.children.length; i++) {
              if (!this.validTask(item.children[i])) {
                return false
              }
            }
          }
        }
      }
      this.$confirm({
        title: nextStep ? '确认提交项目计划？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { projectId } = this
      let tasks = this.tasks.map(({ taskId, taskName, taskType, remark, startDate, endDate, children }) => {
        let item = {
          taskId,
          taskName,
          taskType,
          remark,
          startDate,
          endDate,
        }
        if (children && children.length) {
          item.children = children.map(d => ({
            taskId: d.taskId,
            taskPid: d.taskPid,
            taskName: d.taskName,
            taskType: d.taskType,
            ownerId: d.ownerId,
            owner: d.ownerId ? this.users.find(u => u.id == d.ownerId).realName : d.owner,
	          ownerType: 1,
            startDate: d.startDate,
            endDate: d.endDate,
            remark: d.remark,
            budgets: d.budgets.map(({ budgetId, budgetPid }) => ({ budgetId, budgetPid })),
          }))
        }
        return item
      })
      let params = {
        projectId,
        tasks,
        nextStep,
      }
      this.saving = true
      applyTasks(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.applied = true
            } else {
              this.$message.success('操作成功')
              this.$router.push(`../view/plan?id=${projectId}`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    cancelBudgetModal() {
      this.showBudgetModal = false
    },
    setBudgets(record) {
      this.currentRecord = record
      this.showBudgetModal = true
      this.selectedBudgetKeys = record.budgetIds || []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedBudgetKeys = [...selectedRowKeys]
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.isRoot == 1,
        },
      }
    },
    onSaveTaskBudgets() {
      this.currentRecord.budgetIds = [...this.selectedBudgetKeys]
      this.currentRecord.budgets = this.budgets.filter(d => this.selectedBudgetKeys.includes(d.budgetId))
      this.cancelBudgetModal()
    },
  },
  created() {
    this.init()
  },
}
</script>
